import React from "react";

export function EmptyStateIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      fill="none"
      viewBox="0 0 64 64"
    >
      <rect
        width="36"
        height="48"
        x="18"
        y="5"
        fill="rgb(var(--oui-color-base-10))"
        rx="4"
      ></rect>
      <rect
        width="36"
        height="48"
        x="11"
        y="12"
        fill="url(#paint0_linear_309_13641)"
        rx="4"
      ></rect>
      <rect
        width="36"
        height="48"
        x="9"
        y="10"
        fill="url(#paint1_linear_309_13641)"
        rx="4"
      ></rect>
      <path
        fill="rgb(var(--oui-color-base-5))"
        d="M36.636 53.323V50H6v3.323C6 55.91 7.943 58 10.462 58H41c-2.392 0-4.364-2.168-4.364-4.663"
      ></path>
      <rect
        width="9"
        height="2"
        x="15"
        y="16"
        fill="rgb(var(--oui-color-base-4))"
        rx="1"
      ></rect>
      <rect
        width="16"
        height="2"
        x="15"
        y="24"
        fill="rgb(var(--oui-color-base-4))"
        rx="1"
      ></rect>
      <rect
        width="12"
        height="3"
        x="28"
        y="29"
        fill="rgb(var(--oui-color-base-3))"
        rx="1.5"
      ></rect>
      <path
        fill="rgb(var(--oui-color-base-3))"
        d="M33 23a2 2 0 012-2h1.5a1.5 1.5 0 010 3H34a1 1 0 01-1-1z"
      ></path>
      <rect
        width="9"
        height="3"
        x="29"
        y="37"
        fill="rgb(var(--oui-color-base-3))"
        rx="1.5"
      ></rect>
      <rect
        width="13"
        height="2"
        x="15"
        y="30"
        fill="rgb(var(--oui-color-base-4))"
        rx="1"
      ></rect>
      <rect
        width="15"
        height="2"
        x="15"
        y="36"
        fill="rgb(var(--oui-color-base-4))"
        rx="1"
      ></rect>
      <rect
        width="24"
        height="2"
        x="15"
        y="42"
        fill="rgb(var(--oui-color-base-4))"
        rx="1"
      ></rect>
      <path
        fill="rgb(var(--oui-color-base-8))"
        fillRule="evenodd"
        d="M27.24 30.022a12.451 12.451 0 1122.195 9.87l5.328 5.328-1.58 1.58-5.241-5.24a12.452 12.452 0 01-20.703-11.537zm14.193 12.39A10.156 10.156 0 1037.47 22.49a10.156 10.156 0 003.963 19.92z"
        clipRule="evenodd"
      ></path>
      <path
        fill="rgb(var(--oui-color-base-2))"
        fillRule="evenodd"
        d="M27.24 29.022a12.451 12.451 0 1122.195 9.87l5.328 5.328-1.58 1.58-5.241-5.24a12.452 12.452 0 01-20.703-11.537zm14.193 12.39A10.156 10.156 0 1037.47 21.49a10.156 10.156 0 003.963 19.92z"
        clipRule="evenodd"
      ></path>
      <path
        fill="rgb(var(--oui-color-base-8))"
        d="M51.755 43.867c-.99.99-.99 2.596 0 3.586l3.754 3.754a2.536 2.536 0 103.586-3.586l-3.754-3.754a2.536 2.536 0 00-3.586 0z"
      ></path>
      <path
        fill="rgb(var(--oui-color-base-2))"
        d="M51.755 42.867c-.99.99-.99 2.596 0 3.586l3.754 3.754a2.536 2.536 0 103.586-3.586l-3.754-3.754a2.536 2.536 0 00-3.586 0z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_309_13641"
          x1="27.286"
          x2="48.844"
          y1="55.742"
          y2="25.703"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-10))"></stop>
          <stop offset="1" stopColor="rgb(var(--oui-color-base-9))"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_309_13641"
          x1="25.286"
          x2="46.844"
          y1="53.742"
          y2="23.703"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-gradient-neutral-end))"></stop>
          <stop
            offset="1"
            stopColor="rgb(var(--oui-gradient-neutral-start))"
          ></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default EmptyStateIcon;
